<product-view-details-quote-attributes [product]="product"
                                       class="w-12"></product-view-details-quote-attributes>

<button [buttonStyle]
        (click)="openRequestQuoteModal()"
        class="w-12 p-r-0-s p-l-0-s m-t-8">
    {{ 'request quote' | translate }}
</button>
@if(bottomText){

<div class="p2 p-r p-l p-t-1 p-b-1 m-t-2 center"
     [ngClass]="{'col-3' : !!requestQuoteMessage}"
     [innerHtml]="bottomText">
</div>
}